import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { id: 'chi-siamo', label: 'Chi siamo' },
    { id: 'processo', label: 'Processo' },
    { id: 'contatti', label: 'Contatti' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md transition-all duration-300">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div
            className="flex items-center cursor-pointer"
            onClick={() => scrollToSection('hero')}
          >
            <img
              src="https://customer-assets.emergentagent.com/job_pmi-invest/artifacts/tuz22l37_Logo%20AEH_2.2.png"
              alt="Alfa Equity Holding"
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-sm font-medium text-gray-700 transition-colors duration-200 hover:text-blue-900"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('contatti')}
              className="bg-blue-900 text-white px-6 py-2 rounded-md hover:bg-blue-800 transition-all duration-200 hover:shadow-lg"
            >
              Contattaci
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="text-gray-800" size={24} />
            ) : (
              <Menu className="text-gray-800" size={24} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-100 transition-colors duration-200"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('contatti')}
              className="w-full mt-2 mx-4 bg-blue-900 text-white px-6 py-2 rounded-md hover:bg-blue-800 transition-all duration-200"
              style={{ width: 'calc(100% - 2rem)' }}
            >
              Contattaci
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;